import { initializeApp } from "firebase/app";
import { getFirestore } from "@firebase/firestore"
import { getAnalytics } from "firebase/analytics";
import { getAuth, createUserWithEmailAndPassword } from "firebase/auth";
import { getStorage } from 'firebase/storage';
// const firebaseConfig = {
//   apiKey: process.env.REACT_APP_apiKey,
//   authDomain: process.env.REACT_APP_authDomain,
//   projectId: process.env.REACT_APP_projectId,
//   storageBucket: process.env.REACT_APP_storageBucket,
//   messagingSenderId: process.env.REACT_APP_messagingSenderId,
//   appId: process.env.REACT_APP_appId,
// //   measurementId: process.env.REACT_APP_measurementId
// };

const firebaseConfig = {
    apiKey: "AIzaSyBIT_Eo4-KmnBM_JOSe7s8TWKF9d8x5G0o",
    authDomain: "peridots-cosplay-collections.firebaseapp.com",
    projectId: "peridots-cosplay-collections",
    storageBucket: "peridots-cosplay-collections.appspot.com",
    messagingSenderId: "643169926259",
    appId: "1:643169926259:web:fd790f16884ebb199abe06",
    measurementId: "G-EYDXCJ29JB",
    storageBucket: "peridots-cosplay-collections.appspot.com"
};

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

export { auth, db, storage };